import { render, staticRenderFns } from "./ICCProfileSelector.vue?vue&type=template&id=56bd4c50&scoped=true"
import script from "./ICCProfileSelector.vue?vue&type=script&lang=js"
export * from "./ICCProfileSelector.vue?vue&type=script&lang=js"
import style0 from "./ICCProfileSelector.vue?vue&type=style&index=0&id=56bd4c50&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bd4c50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56bd4c50')) {
      api.createRecord('56bd4c50', component.options)
    } else {
      api.reload('56bd4c50', component.options)
    }
    module.hot.accept("./ICCProfileSelector.vue?vue&type=template&id=56bd4c50&scoped=true", function () {
      api.rerender('56bd4c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/psd-layers/modal/ICCProfileSelector.vue"
export default component.exports